<template>
		<div>
			<div class="answer-container">
        <question
          :curQuestion="curQuestion"
          :practiceName="practiceName"
          :curQuestionIndex="curQuestionIndex"
          :qList="qList"
          @btntopre="toPre"
          @btntonext="toNext"
        ></question>
        <qList
          v-on:qListClick="qListClick"
          :qList="qList"
        ></qList>
			</div>
		</div>
</template>

<script>
  import {getUrlKey} from '../../untils/common.js'
  import question from './children/question.vue'
  import qList from './children/qList.vue'
  import {ApiGetPQList, ApiGetPQuestion, ApiSavePractice, ApiGetAnalysis, ApiGetExamQuestions} from '../../net/exam/index.js'
  export default {
    data: function () {
      return {
        uid: 0,
        examId: 0,
        PopupShow: false, //题目列表显示
        exitShow: false, // 退出弹窗
        practiceName: '',
        curQuestionIndex: 0,
        qList:[],
        curQuestion: {
          questionId: 0,
          questionType: 3,
          answerStatus: 0,
          options: [], // 当前题的选项
          title: '', // 当前题的题干
          trueAnswer: '', // 正确答案
          studentAnswer: '', // 学生的答案
          analysis: '' ,// 答题解析
        },
      }
    },
    components: {question, qList},
    computed: {
      questionId: function () {
        return this.qList[this.curQuestionIndex].questionId
      },
    },
    methods: {
      getQList: function () {
        const params = {
          examId: this.examId,
          uid: this.uid,
          finished: true
        }
        ApiGetExamQuestions(params).then(res=>{
       //   console.log(res)
          if (res.code == 200) {
            this.qList = res.value.questions
            this.practiceName = res.value.practiceName
            this.getQuestion()
          }

        }).catch(err=>{

        })
      },
      getQuestion: function () {
        const params = {
          practiceId: this.examId,
          questionId: this.questionId,
          uid: this.uid
        }
        ApiGetPQuestion(params).then(res=>{
           if (res.code == 200) {
           //  console.log('获取试题',res)
             const _options = this.handlOption(res)
             this.curQuestion = {...res.value, options: _options}
           }
        }).catch(err=>{

        })

      },
      handlOption: function (res) {
        let _options = []
        if (res.value.questionType == 3) {
          _options = [{option: '1', content: '正确', status: 0}, {option: '2', content: '错误', status: 0}]
        } else {
          _options = JSON.parse(res.value.options).map(item=>{
            let option = '', content = ''
            for (name in item) {
               option = name
               content = item[name]
            }
            return {option, content, status: 0}
          })
        }
        if (res.value.studentAnswer) {
          _options = _options.map(item=>{
            if (res.value.studentAnswer.indexOf(item['option']) != -1){
              if (res.value.trueAnswer.indexOf(item['option']) != -1) {
                return {...item, status: 2} //选对了
              } else {
                return {...item, status: 1} //选错了
              }

            }
            return item // 未选
          })
        }
        return _options
      },
      qListClick: function (index) {
        this.curQuestionIndex = index
        this.getQuestion()
      },
      toPre: function () {
        if (this.curQuestionIndex <= 0) {
          this.$message.warning('已经是第一题了')
          return
        }
        this.curQuestionIndex --
        this.getQuestion()
      },
      toNext: function () {
        if (this.curQuestionIndex >= this.qList.length - 1) {
          this.$message.warning('已经是最后一题了')
          return
        }
        this.curQuestionIndex ++
        this.getQuestion()

      }
    },
    mounted: function () {
      this.examId = getUrlKey('eid',window.location.href) || 0
      this.getQList()
    }
  }
</script>

<style scoped>
  .answer-container{
  	width: 1140px;
  	margin:0 auto;
  	border-radius: 6px;
  	margin-top: 24px;
  	overflow: hidden;
  	margin-bottom: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Analysis/Analysis.vue